import React, { Dispatch, useEffect, useState } from 'react';
import { DataType, ExportBtnProps } from './types';
import { Action } from 'typesafe-actions';
import { useSelector, useDispatch } from 'react-redux';
import TitlePage from '../../components/TitlePage';
import { ApplicationState } from '../../store';
import Filter from './Filter';
import { ColumnType } from 'antd/lib/table';
import TableSort from '../../components/TableSort';
import { useWindowSize } from '../../hook/useWindowSize';
import ModalNovoAtendimento from './Modal/NovoAtendimento';
import ModalConversation from './Modal/Conversation';
import { Sorter, sorterParamsHandle } from '../../utils/sorte';
import { HandleClickRowActive } from '../../utils/handleclickrowactive';
import { loadRequest, sorterAtendimentos } from '../../store/ducks/atendimentos/actions';
import { ContFilter, StyledContainer } from './style';
import AnchorButton from '../../components/AnchorButton';
import CardMobile from './Mobile/CardMobile';
import Severity from './components/GetSeveridade';
import GetStatus from '../../components/GetStatus';
import mask from '../../utils/mask';
import moment from 'moment';
import TextTable from '../../components/TextTable';
import Reresh from '../../components/Refresh';
import { listaAtendimento } from './components/services';
import { dadosFormatados } from './Utils/formataTabela';
import { ExportBtn } from 'components/_REFACTORED/ExportBtn';
import { FilterOutlined } from '@ant-design/icons';

const Atendimento: React.FC = () => {
  const { width }: any = useWindowSize();
  const dispatch = useDispatch<Dispatch<Action>>();

  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const filter = useSelector((state: ApplicationState) => state.Atendimentos.filter);
  const paginations = useSelector((state: ApplicationState) => state.Atendimentos.pagination);
  const loading = useSelector((state: ApplicationState) => state.Atendimentos.loading);
  const ocorrencias = useSelector((state: ApplicationState) => state.Atendimentos.data);
  const [filterActive, setFilterActive] = useState<string[]>([]);

  useEffect(() => {
    if (filter)
      Object.keys(filter as {}).forEach((key) => {
        if (filter[key] === undefined || filter[key] === null || filter[key] === '') {
          delete filter[key];
        }
      });
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  const getData = async () => {
    const { data } = await listaAtendimento.getAllData(
      cddAtivo?.codCdd,
      filter,
      inscricaoAtiva,
      paginations.total
    );

    return dadosFormatados(data.ocorrencias);
  };

  const exportData: ExportBtnProps[] = dadosFormatados(ocorrencias);

  const columns: ColumnType<DataType>[] = [
    {
      title: 'Mensagens',
      align: 'center',
      key: '1',
      dataIndex: 'lido',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text, record) => {
        return <ModalConversation propriedades={record} />;
      },
    },

    {
      title: 'Protocolo',
      align: 'center',
      key: 'protocolo',
      dataIndex: 'protocolo',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 3,
      },
      render: (text) => {
        return text ? (
          <TextTable>{text.toString().padStart(6, '0')}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Classificação de urgência',
      align: 'center',
      key: 'urgencia',
      dataIndex: 'urgencia',
      sorter: {
        compare: Sorter.STRING,
        multiple: 2,
      },
      render(text: string) {
        return <Severity severity={text} />;
      },
    },

    {
      title: 'Tipo de solicitação',
      align: 'center',
      key: 'tipoSolicitacao',
      dataIndex: 'tipoSolicitacao',
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render(text: string) {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },

    {
      title: 'Status',
      align: 'center',
      key: 'status',
      dataIndex: 'status',
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text) => {
        return <GetStatus acronym={text} />;
      },
    },

    {
      title: 'Parceiro',
      align: 'center',
      key: 'parceiro',
      dataIndex: 'parceiro',
      sorter: {
        compare: Sorter.STRING,
        multiple: 6,
      },
      render(text: string) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'N° da(s) nota(s)',
      align: 'center',
      key: 'listaNf',
      dataIndex: 'listaNf',
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render(text: string) {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informada</TextTable>;
      },
    },

    {
      title: 'Data da abertura',
      align: 'center',
      key: 'dtAbertura',
      dataIndex: 'dhAbertura',
      sorter: {
        compare: Sorter.DATE,
        multiple: 8,
      },
      render(text: string) {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },

    {
      title: 'Data da conclusão',
      align: 'center',
      key: 'dhConclusao',
      dataIndex: 'dhConclusao',
      sorter: {
        compare: Sorter.DATE,
        multiple: 9,
      },
      render(text: string) {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Em atendimento</TextTable>
        );
      },
    },

    {
      title: 'Embarcador',
      align: 'center',
      key: 'embarcador',
      dataIndex: 'embarcador',
      sorter: {
        compare: Sorter.STRING,
        multiple: 10,
      },
      render(text: string) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: 'Atendente',
      align: 'center',
      key: 'atendente',
      dataIndex: 'atendente',
      sorter: {
        compare: Sorter.STRING,
        multiple: 11,
      },
      render(text: string) {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
  ];

  return (
    <>
      <Reresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, paginations))
        }
      />
      <Filter />

      <StyledContainer key="20">
        <TitlePage>
          <span className="titleGrid">
            <AnchorButton textRoute={'atendimento'} />
            Atendimentos
          </span>

          {filterActive.length > 0 && (
            <ContFilter>
              {filterActive.map((item) => (
                <p key={item}>
                  {item === 'embarcador' && (
                    <>
                      <FilterOutlined /> Embarcador
                    </>
                  )}
                  {item === 'numNota' && (
                    <>
                      <FilterOutlined />
                      Nota fiscal
                    </>
                  )}
                  {item === 'protocolo' && (
                    <>
                      <FilterOutlined />
                      Protocolo
                    </>
                  )}

                  {item === 'status' && (
                    <>
                      <FilterOutlined />
                      Status{' '}
                    </>
                  )}
                  {item === 'tipoSolicitacao' && (
                    <>
                      <FilterOutlined />
                      Tipo de solicitação{' '}
                    </>
                  )}
                  {item === 'dtAberturaIni' && (
                    <>
                      <FilterOutlined />
                      Período de abertura do atendimento{' '}
                    </>
                  )}
                  {item === 'atendente' && (
                    <>
                      <FilterOutlined />
                      Atendente{' '}
                    </>
                  )}
                  {item === 'urgencia' && (
                    <>
                      <FilterOutlined />
                      Urgencia{' '}
                    </>
                  )}
                </p>
              ))}
            </ContFilter>
          )}

          <div className="box">
            <ModalNovoAtendimento />
            {width > 768 && (
              <div>
                <ExportBtn
                  onGetAllData={getData}
                  screenData={exportData}
                  filename={'Atendimentos'}
                />
              </div>
            )}
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            columns={columns}
            scroll={{ x: 2400 }}
            dataSource={ocorrencias}
            pagination={paginations}
            size={'large'}
            loading={loading}
            style={{ fontSize: 10, display: 'inline' }}
            onRow={(record: any, rowIndex: any) => {
              return {
                onClick: (event: React.MouseEvent<HTMLElement>) =>
                  HandleClickRowActive(event, record),
              };
            }}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
                  cddAtivo?.codCdd as number,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
              dispatch(sorterAtendimentos(sorterParamsHandle(sorter)));
            }}
          />
        )}
        {width < 768 && <CardMobile props={ocorrencias} />}
      </StyledContainer>
    </>
  );
};

export default Atendimento;
